'use strict'

import HttpClient from './HttpClient'

class User extends HttpClient {
  loginHeaders = {
    'Authorization': 'Bearer ' + process.env.VUE_APP_LOGISTY_ADMIN_KEY
  }
  passwordLogin (username, password) {
    var url = '/api/admin/login'
    var data = {
      phoneNumber: username,
      password: password
    }
    return this.sendPost(url, this.loginHeaders, data)
  }
  addNewUser (data) {
    var url = '/api/admin/create/new/user'

    return this.sendPost(url, this.headers, data)
  }
  deleteUser (data) {
    var url = '/api/admin/user/delete'

    return this.sendDelete(url, this.headers, data)
  }
  updateUser (data) {
    var url = '/api/admin/edit/user/info'

    return this.sendPut(url, this.headers, data)
  }
  updateUserCompany (data) {
    var url = '/api/admin/edit/user/company/by/email'

    return this.sendPut(url, this.headers, data)
  }
  getUserAll (data) {
    var url = '/api/admin/company/user/all'

    return this.sendPost(url, this.headers, data)
  }
}

export default User
